


























































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import ajax from "@/lib/ajax";
@Component
export default class extends Vue {
  content: any = "";
  emailChips: any[] = [];
  subject: string = "";
  @Prop({ default: true }) public dialog!: boolean;
  @Emit("close-dialog")
  close() {
    return false;
  }
  created() {}

  async sendEmailByList() {
    const payload = {
      emailList: this.checkedPassengers.map(({ email }) => email),
      subject: this.subject,
      body: this.content,
    };
    await ajax.post("/api/services/app/Admin/SendEmailByList", payload);
    this.close();
  }

  get checkedPassengers() {
    return this.$store.state.flightPassengers.checkedPassengerList;
  }
}
